export const LIFE_RING_ID = "LifeRingId";
